import { META, FESTIVALS } from './data';
export default function Footer({ setPage }) {
  return (
    <footer className="bg-[#0A0908] text-[#FBF6E8] border-t border-[#FBF6E8]/10">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12 py-14 grid md:grid-cols-[1.4fr_1fr_1fr] gap-10">
        <div>
          <p className="font-serif italic text-3xl">{META.brand}</p>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#C9963E] mt-2">{META.tagline} · est. {META.est}</p>
          <p className="text-sm text-[#FBF6E8]/55 mt-5 leading-[1.7] max-w-md">A small production company. Twelve films a year, half brand, half non-fiction. We pick our crews carefully and always carry our own equipment.</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#C9963E] mb-3">London</p>
          <p className="text-sm text-[#FBF6E8]/85 leading-relaxed">Unit 4, The Bagel Factory<br />Hackney Wick E9 5BU</p>
          <p className="font-mono text-[11px] text-[#FBF6E8]/55 mt-2">+44 20 3637 0184</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#C9963E] mb-3">New York</p>
          <p className="text-sm text-[#FBF6E8]/85 leading-relaxed">107 Grand Street<br />SoHo · NY 10013</p>
          <p className="font-mono text-[11px] text-[#FBF6E8]/55 mt-2">+1 212 555 0184</p>
        </div>
      </div>
      <div className="border-y border-[#FBF6E8]/10 overflow-hidden py-3">
        <div className="flex gap-12 animate-[scroll_60s_linear_infinite] whitespace-nowrap font-mono text-[10px] tracking-[0.3em] uppercase text-[#FBF6E8]/45">
          {[...FESTIVALS, ...FESTIVALS, ...FESTIVALS].map((f, i) => <span key={i}>{f} <span className="text-[#C9963E] mx-2">·</span></span>)}
        </div>
      </div>
      <div className="px-6 lg:px-12 py-5 max-w-[1500px] mx-auto flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] tracking-[0.3em] uppercase text-[#FBF6E8]/30">
        <span>© 2026 {META.brand} Production Ltd · A boutique film studio</span>
        <div className="flex gap-6">
          <button onClick={() => setPage('crew')} className="hover:text-[#C9963E]">Crew</button>
          <a href="#" className="hover:text-[#C9963E]">Press</a>
          <a href="#" className="hover:text-[#C9963E]">Privacy</a>
        </div>
      </div>
      <style>{`@keyframes scroll { from { transform: translateX(0); } to { transform: translateX(-33.33%); } }`}</style>
    </footer>
  );
}
